import { generateItems } from 'domain/common';
import { Medium } from 'domain/lib';

const { actions, selectors, reducer } = generateItems('Medium', Medium);

export { actions, selectors, reducer };
